import React, { useState } from "react";
import { USER_ROLES } from "../../constants/roles";
import RegisterOptionTabs from "../Tabs/RegisterOptionTabs";
import { useNavigate } from "react-router-dom";
import { STORAGE_KEYS } from "../../constants/keys";

const options = {};
interface Props {
  redirectURI: string;
  clientID: string;
  proceedingRole: string;
  handleRegisterOptionSelect: (role: string) => void;
}
const RegistrationOption: React.FC<Props> = ({
  redirectURI,
  clientID,
  proceedingRole,
  handleRegisterOptionSelect,
}) => {
  const [optionSelect, setOptionSelect] = useState("register");
  // const [proceedingRole, setProceedingRole] = useState(
  // role || USER_ROLES?.CENTER
  // );
  const navigate = useNavigate();

  // const handleRegisterOptionSelect = (role: string) => {
  //   setProceedingRole(role);
  // };

  const handleOptionSelect = (option: string) => {
    setOptionSelect(option);
  };

  const handleNavToSignIn = () => {
    navigate(
      `/sign-in${clientID ? "?client_id=" + clientID : ""}${
        redirectURI ? "&redirect_URI=" + redirectURI : ""
      }`,
      { state: { role: proceedingRole } }
    );
  };
  const handleRegisterNow = () => {
    navigate(
      `/create-account${clientID ? "?client_id=" + clientID : ""}${
        redirectURI ? "&redirect_URI=" + redirectURI : ""
      }`,
      { state: { role: proceedingRole } }
    );
  };
  return (
    <>
      <div>
        {/* <RegisterOptionTabs
          optionSelect={optionSelect}
          handleOptionSelect={handleOptionSelect}
        /> */}
        <div className="w-full md:max-w-[345px] flex flex-col gap-5 md:gap-9">
          <h3 className="text-xl md:text-2xl font-bold text-secondary text-start">
            Create an account
          </h3>
          <div className="flex flex-col items-center gap-4 ">
            <div
              className={`border ${
                proceedingRole === USER_ROLES?.CEO
                  ? "border-primary bg-white"
                  : "border-secondaryVariant"
              } hover:border-primary rounded-[10px] py-3 px-4 w-full flex items-center justify-left gap-3 cursor-pointer hover:bg-white`}
              onClick={() => {
                handleRegisterOptionSelect(USER_ROLES?.CEO);
              }}
            >
              <input
                name="ceo"
                type="radio"
                className="appearance-none shrink-0 checked:bg-primary border border-secondaryVariant checked:border-primary checked:ring-1 ring-white ring-inset rounded-full w-4 h-4 cursor-pointer"
                checked={proceedingRole === USER_ROLES?.CEO}
                readOnly
              />
              <label
                htmlFor=""
                className="text-base text-secondary cursor-pointer font-medium"
              >
                I’m the CEO/Owner
              </label>
            </div>
            <div
              className={`border ${
                proceedingRole === USER_ROLES?.CENTER
                  ? "border-primary bg-white"
                  : "border-secondaryVariant"
              } hover:border-primary rounded-[10px] py-3 px-4 flex items-center justify-left  gap-3 cursor-pointer w-full hover:bg-white`}
              onClick={() => {
                handleRegisterOptionSelect(USER_ROLES?.CENTER);
              }}
            >
              <input
                name="center"
                type="radio"
                className="appearance-none shrink-0 checked:bg-primary border border-secondaryVariant checked:border-primary checked:ring-1 ring-white ring-inset rounded-full w-4 h-4 cursor-pointer"
                checked={proceedingRole === USER_ROLES?.CENTER}
                readOnly
              />
              <label
                htmlFor=""
                className="text-base text-secondary cursor-pointer font-medium"
              >
                I’m a Center Director
              </label>
            </div>
            <div
              className={`border ${
                proceedingRole === USER_ROLES?.TEACHER
                  ? "border-primary bg-white"
                  : "border-secondaryVariant"
              } hover:border-primary rounded-[10px] py-3 px-4 w-full flex items-center justify-left gap-3 cursor-pointer hover:bg-white`}
              onClick={() => {
                handleRegisterOptionSelect(USER_ROLES?.TEACHER);
              }}
            >
              <input
                name="teacher"
                type="radio"
                className="appearance-none shrink-0 checked:bg-primary border border-secondaryVariant checked:border-primary checked:ring-1 ring-white ring-inset rounded-full w-4 h-4 cursor-pointer"
                checked={proceedingRole === USER_ROLES?.TEACHER}
                readOnly
              />
              <label
                htmlFor=""
                className="text-base text-secondary cursor-pointer font-medium"
              >
                I’m a Teacher
              </label>
            </div>

            <div
              className={`border ${
                proceedingRole === USER_ROLES?.PARENT
                  ? "border-primary bg-white"
                  : "border-secondaryVariant"
              } hover:border-primary rounded-[10px] py-3 px-4 w-full flex items-center justify-left gap-3 cursor-pointer hover:bg-white`}
              onClick={() => {
                handleRegisterOptionSelect(USER_ROLES?.PARENT);
              }}
            >
              <input
                name="parent"
                type="radio"
                className="appearance-none shrink-0 checked:bg-primary border border-secondaryVariant checked:border-primary checked:ring-1 ring-white ring-inset rounded-full w-4 h-4 cursor-pointer"
                checked={proceedingRole === USER_ROLES?.PARENT}
                readOnly
              />
              <label
                htmlFor=""
                className="text-base text-secondary cursor-pointer font-medium"
              >
                I’m a Parent
              </label>
            </div>
          </div>

          <button className="btnPrimary" onClick={handleRegisterNow}>
            Register now
          </button>
          <p className="text-base text-secondaryVariant flex items-center justify-center gap-2">
            Already have an account?
            <button
              className="text-secondary font-medium"
              onClick={handleNavToSignIn}
            >
              Sign In{" "}
            </button>
          </p>
        </div>
      </div>
    </>
  );
};

export default RegistrationOption;
